module.exports = __webpack_public_path__ + "img/vertical_6_2_9005.3f980082.png";